<template>
  <div></div> 
</template>
<script>
export default {
  mounted() {
    if (this.$route.path != "/") {
      this.$store.dispatch("addNotification", {
        value: this.$t('notifications.redirect'),
        status: 'danger',
        remove: true
      })
      this.$router.push(`/`)
    }
  }
}
</script>